import { Injectable } from "@angular/core";

@Injectable()
export class FormatIsoAddressFieldsService {
  getNextLine(input1?: string, input2?: string, input3?: string, input4?: string, input5?: string, input6?: string): string {
    return (input1?.trim() || input2?.trim() || input3?.trim() || input4?.trim() || input5?.trim() || input6?.trim()) ? "\n" : "";
  }

  getFieldsValue(field1?: string, field2?: string, field3?: string, field4?: string, field5?: string, field6?: string): string {
    if(!this.isStringEmptyOrUndefined(field1)) {
      return  (!this.isStringEmptyOrUndefined(field2) || 
                !this.isStringEmptyOrUndefined(field3) ||
                !this.isStringEmptyOrUndefined(field4) ||
                !this.isStringEmptyOrUndefined(field5) ||
                !this.isStringEmptyOrUndefined(field6)) ? (field1 + ", ") : (field1 + "");
    }
    return "";
  }

  isStringEmptyOrUndefined(input?: string ): boolean {
    return !input?.trim();
  }
}